jQuery(document).ready(function() {
	/*menu slider toggle - the hamburger button opens AND closes the popup menu*/
	jQuery('.left_hamburger').on('click', function(e){
	    e.preventDefault();
	    var $popup = jQuery('.left-popup-menu');
	    var $hamburgers = jQuery('.left_hamburger');
	    var isOpen = $popup.hasClass('menu-open');

	    $popup.toggleClass('menu-open', !isOpen);
	    $hamburgers.toggleClass('hamburger-active', !isOpen);
	    // lets the header switch to its "menu open" look (styles in cru-custom.css)
	    jQuery('body').toggleClass('mobile-menu-open', !isOpen);
	});

	jQuery('a.banner-close').on('click', function(e){
	    e.preventDefault();
	    jQuery('.header_notif').slideUp();
	});

	var $stickyInner = jQuery('.header-container[data-sticky="true"]');
	if ($stickyInner.length) {
		var $header = jQuery('.cru_header_logo_centered');
		var headerHeight = $header.outerHeight();
		if ($stickyInner.data('sticky-padding') === true) {
			jQuery('body').css('padding-top', headerHeight + 'px');
		}

		var lastScrollTop = 0;
		var scrollThreshold = 8;

		jQuery(window).on('scroll.stickyHeader', function() {
			var st = jQuery(this).scrollTop();
			var diff = st - lastScrollTop;

			if (Math.abs(diff) < scrollThreshold) return;

			if (diff > 0 && st > headerHeight) {
				$header.addClass('scrolled-down');
			} else {
				$header.removeClass('scrolled-down');
			}

			lastScrollTop = st;
		});
	}

	/*add "scrolled" class whenever the page is scrolled away from the top, regardless of direction*/
	var $headerWrap = jQuery('.cru_header_logo_centered');
	function toggleScrolledClass() {
		$headerWrap.toggleClass('scrolled', jQuery(window).scrollTop() > 0);
	}
	jQuery(window).on('scroll.headerScrolled', toggleScrolledClass);
	toggleScrolledClass();


	setTimeout(function(){
		if(jQuery('.hero_main_container').length > 0){
			var currentSlide = jQuery('.hero_main_container').slick('slickCurrentSlide');
			var header_type = jQuery('#slick-slide0'+currentSlide).attr('header-type');
			jQuery('.cru_header_logo_centered').removeClass('dark');
			jQuery('.cru_header_logo_centered').removeClass('light');
			jQuery('.cru_header_logo_centered').addClass(header_type);
		}
	}, 3000);


	jQuery('.hero_main_container').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		var header_type = jQuery('#slick-slide0'+nextSlide).attr('header-type');
		jQuery('.cru_header_logo_centered').removeClass('dark');
		jQuery('.cru_header_logo_centered').removeClass('light');
		jQuery('.cru_header_logo_centered').addClass(header_type);
	});
});

/* Header menu items that only open a dropdown are linked to "#" in the menu. Stop them adding # to the address and
   jumping the page to the top; the dropdown still opens on hover and keyboard focus */
document.addEventListener('click', function (event) {
	var link = event.target.closest && event.target.closest('a.header-menu__link[href="#"]');
	if (link) event.preventDefault();
});
